import ReuseableTable from "components/Tables/ReuseableTable";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { Card, Col, Container, Row, Spinner } from "reactstrap";
import { verifyEndorsmentBadge } from "store/actions/VerifyBadgesAction";

const VerifyEndorseBadge = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dataLoader, setDataLoader] = useState(true);
  useEffect(() => {
    dispatch(
      verifyEndorsmentBadge(id, () => {
        setDataLoader(false);
      })
    );
  }, []);
  const { verifyEndorsementBadge } = useSelector((state) => state.verifyBadges);
  const TABLE_DATA = {
    columns: [
      "Fan Name",
      "Fan Email",
      "Athlete Name",
      "Athlete Email",
      "Purchase Amount",
      "Purchase Date",
    ],
    keyMap: {
      "Fan Name": "fanName",
      "Fan Email": "fanEmail",
      "Athlete Name": "athleteFirstName",
      "Athlete Email": "athleteEmail",
      "Purchase Amount": "dataAmount",
      "Purchase Date": "dataCreatedAtSeconds",
    },
    data: {
      fanName: verifyEndorsementBadge.fan.name,
      fanEmail: verifyEndorsementBadge.fan.email,
      athleteFirstName:
        verifyEndorsementBadge.athlete.first_name +
        " " +
        verifyEndorsementBadge.athlete.last_name,
      athleteEmail: verifyEndorsementBadge.athlete.email,
      dataAmount: verifyEndorsementBadge.data.amount,
      dataCreatedAtSeconds: moment
        .unix(verifyEndorsementBadge.data.createdAt.seconds)
        .format("D MMM YYYY"),
    },
  };
  return (
    <Container className="pt-4">
      <Row className="mt-4">
        <Col md="12">
          <Card className="p-4">
            <h1 className="text-center">Endorsement badge details </h1>
            {dataLoader ? (
              <div className="text-center">
                <Spinner color="primary" />
              </div>
            ) : Object.keys(verifyEndorsementBadge).length === 0 ? (
              <p>This Badge not found</p>
            ) : (
              <>
                <ReuseableTable {...TABLE_DATA} />
              </>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyEndorseBadge;
